module.exports = __webpack_public_path__ + "static/media/icon-close-white.c94e382c.svg";